import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Dialogs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true
		}

		this.handleAccept = this.handleAccept.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	componentDidUpdate

	handleAccept() {
		this.props.handleDelete(this.props.id);
	};

	handleClose() {
		this.props.handleClose();
	}

	render() {
		return (
			<Dialog
				open={this.state.open}
				keepMounted
				onClose={this.handleClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle style={{ fontSize: "50px" }} id="alert-dialog-slide-title">{this.props.title}</DialogTitle>
				<DialogContent>
					<DialogContentText style={{ fontSize: "4vh" }} id="alert-dialog-slide-description">
						{this.props.message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={
							this.props.type === "warning" ?
								this.handleAccept :
								this.handleClose
						}
						variant={
							this.props.type !== "warning" ?
								"outlined" :
								"contained"
						}
						color={"primary"}
					>
						Aceptar
					</Button>
					{
						this.props.type === "warning" &&
						<Button onClick={this.handleClose} variant="outlined" color={"primary"}>
							Cancelar
						</Button>
					}
				</DialogActions>
			</Dialog>
		);
	}
}

export default Dialogs;